// ----------------------------------------------------------------------

export default function Tooltip(theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.tooltip.main,
          color: theme.palette.grey[800],
          border: '1px solid #000000',
        },
        arrow: {
          color: theme.palette.grey[800],
        },
      },
    },
  };
}
